import {
  getRoot,
  IAnyModelType,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';
import { modelWithCRUD } from '../utils/modelWithCRUD';
import { RootModelType } from '../Root';
import { CommomMixin, ResponsibleMixin } from '../Mixins';

export const Contact = types
  .compose(
    CommomMixin,
    ResponsibleMixin,
    types.model({
      id: types.union(types.identifier, types.identifierNumber),
      name: types.string,
      emails: types.array(types.string),
      phone: types.maybeNull(types.string),
      mobile: types.maybeNull(types.string),
      thumbnail: types.maybeNull(types.string),
    })
  )
  .named('Contact')
  .views((self) => ({
    get initials() {
      return self.name
        .split(' ')
        .map((e) => (e.length > 0 ? e[0] : ''))
        .join('')
        .toUpperCase();
    },
  }));

export const ContactStore = modelWithCRUD('contacts', Contact).named(
  'ContactStore'
);

export const ContactReference = types.reference(
  types.late((): IAnyModelType => Contact),
  {
    get(identifier, parent): any {
      return (getRoot(parent!) as RootModelType).contactStore.getItemNaive(
        identifier
      );
    },
    set(value) {
      return value.id;
    },
  }
);

export interface IContact extends Instance<typeof Contact> {}
export interface IContactSnapshotIn extends SnapshotIn<typeof Contact> {}
export interface IContactSnapshotOut extends SnapshotOut<typeof Contact> {}
